.gr{gap:0.25rem;}